//
//
// ENUMS TO SHARE BETWEEN:
// - THE NPM MODULE CLIENT SIDE EDITOR
// AND
// - THE NPM MODULE SERVER
// (as in this file needs to be copied manually and be identical for both repositories)
//
//
export interface Dictionary<T> {
	[Key: string]: T;
}
export enum ResponseMessageFromLocalServer {
	NO_USER = 'no user',
	NO_MANIFEST = 'no manifest',
	NO_POLY_CONFIG = 'no poly plugins',
	NO_EDITOR_CONFIG = 'no editor config',
	NO_EDITOR = 'no editor data',
	// NO_EXPORT_TYPE = 'no export type',
	NO_NODE_MODULES = 'no node_modules',
	// NO_ASSETS_CONFIG = 'no assets config, make sure to save your scene',
	NO_LIBS_ROOT = 'no libs root',
	THREEJS_NOT_INSTALLED = 'threejs is not installed',
	XATLAS_NOT_INSTALLED = 'xatlas is not installed',
}
export enum LocalServerUrl {
	ROOT = '/',
	// auth
	TOKEN_CREATE = '/tokens',
	TOKEN_GET = '/token',
	LOGOUT = '/logout',
	// scene
	SCENES = '/scenes',
	SCENE_LOAD = '/scenes/load',
	SCENE_SAVE = '/scenes/save',
	// polyNodes
	POLY_NODES_INDEX = '/poly_nodes',
	POLY_NODE_CREATE = '/poly_nodes/create',
	POLY_NODE_UPDATE = '/poly_nodes/update',
	// SCENE_EXPORT_ENGINE = '/scenes/engine.json',
	// capture
	CAPTURE_ANIMATION_SAVE = '/captures/animation/save',
	CAPTURE_STATIC_SAVE = '/captures/static/save',
	CAPTURE_STATIC_LOAD = '/captures/static/load',
	// configs
	// EXPORT_TYPE_SAVE = '/export_type/save',
	POLY_CONFIG_LOAD = '/poly_config/load.js',
	EDITOR_CONFIG_LOAD = '/editor_config/load.js',
	// assets
	ASSETS = '/assets.json',
	// libraries
	INSTALL_DRACO = '/install/draco.json',
	INSTALL_KTX2 = '/install/ktx2.json',
	INSTALL_XATLAS = '/install/xatlas.json',
	// utils
	STATUS = '/utils/status.json',
}
// When the ManifestContent interface is updated
// make sure to sync it with SceneDataManifestImporter
// to allow the engine to load it.
export type ManifestNodesData = Dictionary<string>;
export interface ManifestContent {
	properties: string;
	root: string;
	nodes: ManifestNodesData;
}
export interface CaptureRequestSaveBody {
	sceneName: string;
	fileDataURL: string;
}
export interface CaptureRequestSaveResponse {
	filePath: string;
}
export interface CaptureRequestLoadQuery {
	sceneName: string;
}
export interface CaptureRequestLoadErrorResponse {
	error: string;
}
// export interface ExportTypeRequestBody {
// 	export: SceneExportType;
// }
export interface AssetsRequestQuery {
	extensionsJoined: string;
}
export interface AssetFileData {
	filePath: string;
	timestamp: number;
}
export interface AssetsRequestResponse {
	error?: string;
	filesData?: AssetFileData[];
}

export const ASSETS_EXTENSIONS_SEPARATOR = ',';
export interface LibrariesInstallQuery {
	libsRoot: string;
}
export interface PolyConfigQuery {
	// raw: '0' | '1';
}
export interface AssetsRequestResponse {
	error?: string;
	paths?: string[];
}
export interface ScenesRequestResponse {
	error?: string;
	scenes?: string[];
}
export interface LoadSceneQuery {
	scene: string | null;
}
// export interface ExportSceneQuery {
// 	scene: string;
// 	minify: '0' | '1';
// 	gzip: '0' | '1';
// 	brotli: '0' | '1';
// }
// export interface ExportSceneResponse {
// 	uncompressed: string;
// 	gzip: string;
// 	brotli: string;
// }
export interface SaveResponse {
	warning?: string;
}

export interface LoadSceneResponse {
	manifest?: ManifestContent;
	editor_data?: object;
	root?: object;
	properties?: object;
	ui?: object;
	jsons_by_name?: Dictionary<object>;
	error?: string;
}

export interface LoadDefaultSceneResponse {
	error: string;
	scene: {
		code: object;
		editor: object;
	};
}
export type LoadPolyConfigResponse = string;
export type LoadEditorConfigResponse = Dictionary<string>;

export interface StatusQueryResponse {
	status: string;
}

// export enum SceneExportType {
// 	TYPESCRIPT = 'typescript',
// 	JAVASCRIPT = 'javascript',
// 	HTML = 'html',
// }

//
// POLY NODES
//
interface PolyNodeDataRegisterDummy {
	context: string;
	type: string;
	data: object;
}
export type PolyNodesIndexResponse = PolyNodeDataRegisterDummy[];
export type PolyNodeCreateRequestBody = PolyNodeDataRegisterDummy;
export interface PolyNodeCreateResponse {
	error?: string;
}
export type PolyNodeUpdateRequestBody = PolyNodeDataRegisterDummy;
export interface PolyNodeUpdateResponse {
	error?: string;
}
export interface UserDataResponse {
	username: string;
	pro: boolean;
}
